import { jsx as _jsx } from "react/jsx-runtime";
import { Modal } from "antd";
import { pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import Previewer from "@/components/Resume/Upload/previewer";
import { useLocale } from "@/hooks/useLocale";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const ResumePreview = ({ isOpen, uploadFiles, showDownload, linkFiles, customMessage, isLink, isUpload, isChatMessage, close, locale, }) => {
    const { t } = useLocale("attachmentResume", locale);
    return (_jsx(Modal, { open: isOpen, width: 1000, onCancel: () => {
            close();
        }, title: _jsx("span", { style: { fontWeight: "700" }, children: t("attachmentResume") }), centered: true, footer: null, height: "90vh", children: _jsx(Previewer, { clearFiles: () => { }, reloadData: () => { }, close: () => {
                close();
            }, showDownload: showDownload, isUpload: isUpload, uploadFiles: uploadFiles, isLink: isLink, linkFiles: linkFiles, isChatMessage: isChatMessage, customMessage: customMessage, locale: locale }) }));
};
export default ResumePreview;
